import { useState, useContext } from "react";
import SelectGroup from "../../group/SelectGroup";
import SlotApi from "../../../api/SlotApi";
import UserContext from "../../../context/UserContext";
import { loginAlert } from "../../common/CustomAlert";

const getPlaceHolder = type => {
    if (type === 'ST001') return 'm.place.naver.com/place/ 주소 입력 & 플레이스 코드 입력';
    if (type === 'ST002') return '상품명 입력';
    return '상품 링크 입력';
}

const AddSlot = props => {
    const { user, updateUserInfo } = useContext(UserContext);
    const { addComplete = () => {}, groups = [], type, sectionTitle } = props;
    const [ keyword, setKeyword ] = useState('');
    const [ prodNm, setProdNm ] = useState('');
    const [ registerGroupId, setRegisterGroupId ] = useState(0);

    const handleKeywordInput = e => setKeyword(e.target.value);
    const handleProdNmInput = e => setProdNm(e.target.value);
    
    const handleRegisterBtn = async () => {
        if (!user || !user.userId) return loginAlert('로그인이 필요합니다.');
        const rslt = await SlotApi.createSlot({
            slotGroupId: registerGroupId || null,
            slotKeyword: keyword,
            slotTargetNm: prodNm,
            slotType: type
        });
        if (rslt && rslt.code === 'success') {
            setKeyword('');
            setProdNm('');
            setRegisterGroupId(0);
            updateUserInfo();
            return addComplete(rslt.slot);
        }
        alert(rslt.message);
    }

    return (
        <div class="section-area">
            <div class="section-header">
                <h1 class="section-header-title">{sectionTitle} 등록</h1>
            </div>
            <div class="section-filter-group add-filter-group">
                <div class="section-filter-col">
                    <SelectGroup groups={groups} selectCallback={setRegisterGroupId} />
                    <input type="search" placeholder="검색 키워드"
                        value={keyword} onChange={handleKeywordInput}
                    />
                </div>
                <div class="section-filter-col">
                    <input type="search" placeholder={getPlaceHolder(type)}
                        value={prodNm} onChange={handleProdNmInput}
                    />
                    <button type="button" class="btn btn-black" onClick={handleRegisterBtn}>
                        <span>등록</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AddSlot;